import { ReplicaType } from "types";
import Version1 from "./v1";
import Version2 from "./v2";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp3-sirius-black-sighted",
  name: `The Daily Prophet\n'Sirius Black Sighted'`,
  nameFormatted: {
    primary: "The Daily Prophet",
    secondary: "'Sirius Black Sighted'",
  },
  origin: "Harry Potter and the Prisoner of Azkaban",

  category: replicaCategories.harryPotter,

  versions: [Version2, Version1],
};

export default data;
